import { first } from 'underscore';
import update from 'immutability-helper';
import {
  CAMERA_PRESENTER,
  VIDEO_FILE,
  AUDIO_FILE,
  IMAGE_FILE,
  MEDIA,
  PDF_FILE,
  SCREEN_PRESENTER
} from '@shoflo/polymer';
import { stageFeaturedPresenter } from '@shoflo/studio-redux/actions';

import { withCurrentParams } from 'actions/utils';
import { BROADCAST_REORDER_SOURCES } from '../../Types';
import { getSourcesSignedUrl } from 'utils/broadcastSourceHelper';
import { orderSources } from '../utils';
import { SOURCE_ORDER_CHANGE } from 'store/eventConstants';

const INITIAL_ORDER_POSITION = 1;

const isMediaSource = sourceType =>
  [VIDEO_FILE, AUDIO_FILE, IMAGE_FILE, MEDIA, PDF_FILE].includes(sourceType);

const isPresenterSource = sourceType => sourceType === CAMERA_PRESENTER;

const getGroupedSources = (sources, sourceType) => {
  if (isMediaSource(sourceType)) {
    return sources.filter(s => isMediaSource(s.type));
  }

  if (isPresenterSource(sourceType)) {
    return sources.filter(s => isPresenterSource(s.type));
  }
};

const getNumberOfScreenShares = sources =>
  sources.filter(s => s.type === SCREEN_PRESENTER).length;

const getDropPosition = (draggedSource, dropIndex, numberOfScreenShares) =>
  draggedSource.type === CAMERA_PRESENTER
    ? dropIndex - numberOfScreenShares
    : dropIndex;

export default (source, dropIndex) => {
  return withCurrentParams(
    (dispatch, { teamId, eventId, broadcastId }, getState, socket) => {
      const {
        broadcastSources: { sources },
        meeting: { attendeeResponse }
      } = getState();

      const groupedSources = getGroupedSources(sources, source.sourceType);

      // Get sorted sources
      const orderedSources = orderSources(groupedSources);
      const dragItemIndex = orderedSources.findIndex(
        ps => ps._id === source.id
      );

      const draggedSource = orderedSources[dragItemIndex];
      const numberOfScreenShares = getNumberOfScreenShares(sources);
      const dropPosition = getDropPosition(
        draggedSource,
        dropIndex,
        numberOfScreenShares
      );

      const reorderedSources = update(orderedSources, {
        $splice: [
          [dragItemIndex, 1],
          [dropPosition, 0, draggedSource]
        ]
      }).map((source = {}, index) => {
        return {
          ...source,
          order: index + INITIAL_ORDER_POSITION,
          value: source.value
        };
      });

      // Make first ordered source featured presenter
      const { _id: presenterId } = first(reorderedSources);
      const shouldBeSetAsFeatured = isPresenterSource(source.sourceType);

      const action = {
        type: BROADCAST_REORDER_SOURCES,
        request: async apiClient => {
          await apiClient.broadcast.updateSourcesOrder(
            teamId,
            eventId,
            broadcastId,
            {
              sources: reorderedSources.map(source => ({
                _id: source._id,
                order: source.order
              }))
            }
          );
          // notify other directors
          socket.emit(SOURCE_ORDER_CHANGE, {
            broadcastId,
            presenterId,
            isPresenterSource: shouldBeSetAsFeatured,
            notifyingDirector:
              attendeeResponse && attendeeResponse.Attendee.AttendeeId
          });

          return await getSourcesSignedUrl(
            reorderedSources,
            apiClient,
            teamId,
            eventId
          );
        }
      };
      dispatch(action);
      // stage as _featured_ after reorder
      if (shouldBeSetAsFeatured) {
        dispatch(stageFeaturedPresenter(presenterId));
      }
    }
  );
};
